import {
  TYPES,
  elementMap,
} from "@/view/ProseMirrorNode/ProseMirrorNode.constants";
import getIsEditorsNote from "../getIsEditorsNote";
import getParagraphIsAllSpecialCharacters from "../getParagraphIsAllSpecialCharacters";

const getAccessibilityControlsParagraphCount = (
  node,
  currentAccessibilityControlsParagraphCount,
  parentIdentifier,
  contentData,
  paragraphIndex,
) => {
  const { paragraph, blockQuote, unorderedListItem } = TYPES;

  // Node types that we'll use to calculate the "paragraph" count,
  // which will likely eventually include node types that aren't paragraph
  const nodeTypesToCount = [paragraph];
  const isTypeToCount = nodeTypesToCount.includes(node.type);

  // We don't want to include paragraphs that contain only special characters
  // (---, ###, etc) in the paragraph count
  const paragraphIsAllSpecialCharacters =
    getParagraphIsAllSpecialCharacters(node);

  // We don't want to include empty paragraphs in the paragraph count
  const isEmptyParagraph = node?.type === paragraph && !node?.content?.length;

  // Paragraph nodes exist _within_ list items and block quotes,
  // but we do not want these to be added to the count
  const isChildOfListItem = parentIdentifier?.includes(
    elementMap[unorderedListItem],
  );
  const isChildOfBlockQuote = parentIdentifier?.includes(
    elementMap[blockQuote],
  );

  // We do not want to add editor's notes to the paragraph count
  const isEditorsNote = getIsEditorsNote(node, paragraphIndex, contentData);

  const shouldAddToCount =
    isTypeToCount &&
    !paragraphIsAllSpecialCharacters &&
    !isEmptyParagraph &&
    !isChildOfListItem &&
    !isChildOfBlockQuote &&
    !isEditorsNote;

  if (shouldAddToCount) {
    currentAccessibilityControlsParagraphCount =
      currentAccessibilityControlsParagraphCount
        ? currentAccessibilityControlsParagraphCount + 1
        : 1;
  }

  return currentAccessibilityControlsParagraphCount;
};

export default getAccessibilityControlsParagraphCount;
